export const HOT_LEAGUES = [
  {
    id: 1639,
    name: 'Ngoại hạng Anh',
    slug: 'ngoai-hang-anh',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Premier-League.webp',
    type: 1
  },
  {
    id: 1134,
    name: 'La Liga',
    slug: 'la-liga',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Spanish-La-Liga.webp',
    type: 1
  },
  {
    id: 1437,
    name: 'Serie A',
    slug: 'seri-a',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/Italian-Serie-A.webp',
    type: 1
  },
  {
    id: 188,
    name: 'Bundesliga',
    slug: 'bundesliga',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/German-Bundesliga.webp',
    type: 1
  },
  {
    id: 1112,
    name: 'Ligue 1',
    slug: 'ligue-1',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/France-Ligue-1.webp',
    type: 1
  },
  {
    id: 13014,
    name: 'Cúp C1 Châu Âu',
    slug: 'cup-c1-chau-au',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/UEFA-Champions-League.webp',
    type: 2
  },
  {
    id: 13115,
    name: 'Cup C2 Châu Âu',
    slug: 'cup-c2-chau-au',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
    type: 2
  },
  {
    id: 16679,
    name: 'V-League',
    slug: 'v-league',
    logo: 'https://bangkeovippro.s3.amazonaws.com/hot-leagues/International-Club-Friendly.webp',
    type: 1
  }
];

export const TAB_LABELS = {
  'totalStandings': 'Tổng quan',
  'homeStandings': 'Sân nhà',
  'awayStandings': 'Sân khách',
  'halfStandings': 'Hiệp 1',
  'homeHalfStandings': 'Sân nhà (Hiệp 1)',
  'awayHalfStandings': 'Sân khách (Hiệp 1)',
  'group_a': 'Bảng A',
  'group_b': 'Bảng B',
  'group_c': 'Bảng C',
  'group_d': 'Bảng D',
  'group_e': 'Bảng E',
  'group_f': 'Bảng F',
  'group_g': 'Bảng G',
  'group_h': 'Bảng H'
};

export const API_ENDPOINTS = {
  LEAGUES_HOT: '/api/leagues/hot',
  LEAGUES_ALL: '/api/leagues',
  RANKINGS: '/api/rankings'
};

export const BANKER = [
  {
    name: "Sbobet",
    value: "31",
  },
  {
    name: "M88",
    value: "17",
  },
  {
    name: "Macauslot",
    value: "1",
  },
  {
    name: "Crown",
    value: "3",
  },
  {
    name: "Ladbrokes",
    value: "4",
  },
  {
    name: "Bet365",
    value: "8",
  },
  {
    name: "Vcbet",
    value: "14",
  },
  {
    name: "10BET",
    value: "22",
  },
  {
    name: "188bet",
    value: "23",
  },
  {
    name: "18bet",
    value: "42",
  },
  {
    name: "Pinnacle",
    value: "47",
  },
];

export const LOCATION = [
  {
    name: "Châu Á",
    slug: "chau-a",
    bg: "bg-aqua-mint",
    bgCell: "bg-pale-aqua dark:bg-pale-dark-aqua",
  },
  {
    name: "Tài Xỉu",
    slug: "tai-xiu",
    bg: "bg-golden-sun",
    bgCell: "bg-yellow-pastel dark:bg-yellow-dark-pastel",
  },
  {
    name: "Châu Âu",
    slug: "chau-au",
    bg: "bg-blue-500 text-white",
    bgCell: "bg-cool-mist dark:bg-cool-dark-mist",
  },
];
